import React, { useMemo } from 'react';
import { string, instanceOf } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { monthDayYear } from '../../../utils/time_helpers';
import { EN_US } from '../../../utils/constants/LanguageRegionCode';

const {
  strings: {
    GIFT_FLOW: {
      GIFT_REVIEW: { PLEASE_CONFIRM_RECIPIENT_DETAILS },
      GIFT_CUSTOMIZE_FORM: { TO, EMAIL, SEND_DATE }
    }
  }
} = StringConstantsMixin;

const GiftConfirmation = ({ recipientName, recipientEmail, sendDate, languageRegionCode }) => {
  const formattedDate = useMemo(() => {
    return monthDayYear(sendDate, languageRegionCode);
  }, [sendDate]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>{PLEASE_CONFIRM_RECIPIENT_DETAILS}</div>
      <div className={styles.label}>
        {TO}: <span>{recipientName}</span>
      </div>
      <div className={styles.label}>
        {EMAIL}: <span>{recipientEmail}</span>
      </div>
      <div className={styles.label}>
        {SEND_DATE}: <span>{formattedDate}</span>
      </div>
    </div>
  );
};

GiftConfirmation.propTypes = {
  recipientName: string.isRequired,
  recipientEmail: string.isRequired,
  sendDate: instanceOf(Date).isRequired,
  languageRegionCode: string
};

GiftConfirmation.defaultProps = {
  languageRegionCode: EN_US
};

export default GiftConfirmation;
